import { mutator } from 'satcheljs';
import { setGetCalendarFolderServiceStatus } from 'owa-agenda-mail-option/lib/actions/internalActions';
import getStore from 'owa-agenda-mail-option/lib/store/store';

export const setGetCalendarFolderServiceStatusMutator = mutator(
    setGetCalendarFolderServiceStatus,
    actionMessage => {
        getStore().getCalendarFoldersServiceStatus = actionMessage.status;
    }
);
